import axios from "axios"
import { BASE_AUTH_URL, BASE_URL, BASE_REST_AUTH_URL } from "./api"


export async function login(userName, passWord) {
    return axios({
        method: 'post',
        url: `${BASE_AUTH_URL}/auth/login/`,
        headers: { 
            'Content-Type': 'application/json'
        },
        auth: {
            username: userName,
            password: passWord
        }
    })
    .then((response) => {
        return response.data
    })
    .catch(error => console.log(error))
}

export async function newLogin(username, password) {
    // console.log('newLogin', username, password)
    return axios({
        method: 'post',
        url: `${BASE_REST_AUTH_URL}/login/`,
        headers: { 
            'Content-Type': 'application/json'
        },
        data: {
            username: username,
            password: password
        }
    })
    .then((response) => {
        // console.log('auth response', response)
        return response
    })
    .catch((error) => {
        console.log(error)
        return error
    })
}

export async function verifyToken(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/verify_token`,
        headers: { 
          "Authorization": `Token ${token}`
        }
    })
    .then(response => {
        // console.log('verify token service response', response)
        return response
    })
    .catch((error) => {
        console.log('unauthorized')
        console.log(error)
        return false
    })
}

export async function registerUser(payload) {
    return axios({
        method: 'post',
        url: `${BASE_REST_AUTH_URL}/registration/`,
        headers: { 
            'Content-Type': 'application/json'
        },
        data: payload
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function verifyEmail(verificationKey) {
    console.log('verify email', verificationKey)
    return axios({
        method: 'post',
        url: `${BASE_REST_AUTH_URL}/registration/verify-email/`,
        data: { 
          "key": verificationKey
        }
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function resendEmailVerification(payload) {
    return axios({
        method: 'post',
        url: `${BASE_REST_AUTH_URL}/registration/resend-email/`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: payload
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function sendPasswordResetLink(payload) {
    return axios({
        method: 'post',
        url: `${BASE_REST_AUTH_URL}/password/reset/`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: payload
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

export async function resetPassword(payload) {
    return axios({
        method: 'post',
        url: `${BASE_REST_AUTH_URL}/password/reset/confirm/`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: payload
    }).then((response) => {
        return response
    }).catch((error) => {
        console.log(error)
        return error
    })
}

